import { ApaduaAPI } from './ApaduaAPI';

export class CompanySizeEmployeesAPI extends ApaduaAPI {
    resource: string = 'api/company-size-employees/';

    getCompanySizeEmployees(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
